import CustomIcon from "../CustomIcon";
import { Box, Stack, Spacer } from "digiwash-components";
import React from "react";

interface IndicatorType {
  step: number | string;
  callout: React.ReactNode;
}

function stepGenerator(step) {
  let collection = {
    icon: null,
    line: null,
  };
  let inProgress = {
    icon: null,
    line: null,
  };
  let delivery = {
    icon: null,
    line: null,
  };

  if (step === 0) {
    collection.icon = "logisticOrangeRight";
    collection.line = "orange.main";
    inProgress.icon = "washingMashin";
    inProgress.line = "gray.light";
    delivery.icon = "logisticGrayLeft";
    delivery.line = null;
  } else if (step === 1) {
    collection.icon = "logisticGreen";
    collection.line = "green.main";
    inProgress.icon = "washingMashinOrange";
    inProgress.line = "orange.main";
    delivery.icon = "logisticGrayLeft";
    delivery.line = null;
  } else if (step === 2) {
    collection.icon = "logisticGreen";
    collection.line = "green.main";
    inProgress.icon = "washingMashinGreen";
    inProgress.line = "green.main";
    delivery.icon = "logisticOrangeLeft";
    delivery.line = null;
  } else if (step === 3) {
    collection.icon = "logisticGreen";
    collection.line = "green.main";
    inProgress.icon = "washingMashinGreen";
    inProgress.line = "green.main";
    delivery.icon = "logisticGreenLeft";
    delivery.line = null;
  } else if (step === 4) {
    collection.icon = "logisticRedRight";
    collection.line = "red.dark";
    inProgress.icon = "washingMashin";
    inProgress.line = "gray.light";
    delivery.icon = "logisticGrayLeft";
    delivery.line = null;
  } else if (step === 5) {
    collection.icon = "logisticGreen";
    collection.line = "green.main";
    inProgress.icon = "washingMashinGreen";
    inProgress.line = "green.main";
    delivery.icon = "logisticRedRight";
    delivery.line = null;
  } else if (step === 6) {
    collection.icon = "logisticRedRight";
    collection.line = "red.dark";
    inProgress.icon = "washingMashin";
    inProgress.line = "gray.light";
    delivery.icon = "logisticGrayLeft";
    delivery.line = null;
  } else if (step === 7) {
    collection.icon = "logisticGreen";
    collection.line = "green.main";
    inProgress.icon = "washingMashinGreen";
    inProgress.line = "green.main";
    delivery.icon = "logisticRedRight";
    delivery.line = null;
  }

  return [collection, inProgress, delivery];
}

function Indicator(props: IndicatorType) {
  let steps = stepGenerator(props.step);
  return (
    <Box p="xxxl" bg="common.white" br="l" style={{ width: "100%" }}>
      <Stack
        style={{ width: "100%", justifyContent: "center" }}
        p="l"
        distribution="space-between"
      >
        {steps.map((item, index) => {
          return (
            <>
              <CustomIcon icon={item.icon} width={24} height={24} />
              {index !== steps.length - 1 ? (
                <>
                  <Spacer size="xm" />
                  <Box bg={item.line} style={{ width: "40%", height: 3 }} />
                  <Spacer size="xm" />
                </>
              ) : null}
            </>
          );
        })}
      </Stack>
      {props.callout}
    </Box>
  );
}

export default Indicator;
